import { render, staticRenderFns } from "./CollectionMagazineNameVolumePossessionInfoTable.vue?vue&type=template&id=18cd5238&scoped=true&"
import script from "./CollectionMagazineNameVolumePossessionInfoTable.vue?vue&type=script&lang=ts&"
export * from "./CollectionMagazineNameVolumePossessionInfoTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cd5238",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VRow})
